module.exports = __webpack_public_path__ + "img/grip-vertical.9e8c45f7.svg";